<template>
  <div class="floating">
    <h2>Ready To Build Your Community?</h2>
    <div class="btn-div">
      <my-button class="btn"></my-button>
    </div>
  </div>
</template>
<script>
import MyButton from "./myButton.vue";
export default {
  name: "Float",
  components: {
    MyButton,
  },
};
</script>
<style scoped>
h2 {
  text-align: center;
}
.floating {
  box-shadow: 3px 2px 3px 3px #e6e6e6;
  border-radius: 0.5rem;
  margin: auto;
  position: absolute;
  background-color: white;
}
.btn-div {
  margin: 15px;
  width: fit-content;
  margin: auto;
}
.btn {
  margin: 18px;
}

@media (max-width: 720px) {
  .floating {
    padding: 1rem;
    width: 20rem;
      bottom: -6rem;
  left: 0;
  right: 0;
  }
  h2 {
    font-size: 20px;
  }
}
@media(min-width:721px){
    .floating{
        width: 40rem;
        left: 0;
        right: 0;
        bottom: -5rem;
        height: 9rem;
    }
    h2{
        margin: 1rem 0;
    }
}
</style>